import { render } from "./CustomDialog.vue?vue&type=template&id=be9270b8&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"

import "./CustomDialog.vue?vue&type=style&index=0&id=be9270b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9270b8"]])

export default __exports__